import { render } from "./zyzb.vue?vue&type=template&id=2b5e4ba4&scoped=true&ts=true"
import script from "./zyzb.vue?vue&type=script&lang=ts"
export * from "./zyzb.vue?vue&type=script&lang=ts"

import "./zyzb.vue?vue&type=style&index=0&id=2b5e4ba4&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5e4ba4"]])

export default __exports__